import { InsightsLabel } from 'components/InsightsLabel/InsightsLabel';
import React from 'react';

type Feedback = 'positive' | 'request' | 'negative';

export type InsightsLabelGroupProps = {
  newInsight?: boolean;
  feedback?: Feedback;
  categories: string[];
  sustainable?: boolean;
};

export const InsightsLabelGroup: React.FC<InsightsLabelGroupProps> = ({
  newInsight,
  feedback,
  categories,
  sustainable,
}) => {
  return (
    <div className="flex flex-wrap gap-1">
      {newInsight && <InsightsLabel variant="new" />}
      {feedback && <InsightsLabel variant={feedback} />}
      {categories &&
        categories.map((category, index) => (
          <InsightsLabel key={index} variant="neutral" text={category} />
        ))}
      {sustainable && <InsightsLabel variant="neutral" text="sustainable" />}
    </div>
  );
};
